// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap-css-only/css/bootstrap.min.css'
import '../build/css/mdb.css'
import '../build/css/style.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueYandexMetrika from 'vue-yandex-metrika'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title + ' | ULKite.ru'

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  if (!nearestWithMeta) return next()

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  }).forEach(tag => document.head.appendChild(tag))

  const ogTags = [
    {
      name: 'og:site',
      content: 'UlKite | Кайтинг Ульяновск'
    },
    {
      name: 'og:image',
      content: '/static/img/logo_large.png'
    },
    {
      name: 'og:image',
      content: '/static/img/logo_small.png'
    }
  ]

  ogTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  }).forEach(tag => document.head.appendChild(tag))

  next()
})

Vue.use(VueYandexMetrika, {
  id: 51442333,
  router: router,
  env: process.env.NODE_ENV
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js